"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @desc Treat string amounts kind of language agnostic. Supports '.' or ',' as a delimiter for fractional digits. Use it in combination with `sanitizeMoney`.
 */
function parseCents(sanitizedAmount) {
    if (!sanitizedAmount)
        return 0;
    const floatText = sanitizedAmount.replace(',', '.');
    const amountInCurrencyUnits = parseFloat(floatText) || 0;
    return Math.round(amountInCurrencyUnits * 100);
}
exports.default = parseCents;
//# sourceMappingURL=parseCents.js.map